import { render, staticRenderFns } from "./player.vue?vue&type=template&id=26dd936f&scoped=true&"
import script from "./player.vue?vue&type=script&lang=js&"
export * from "./player.vue?vue&type=script&lang=js&"
import style0 from "./player.vue?vue&type=style&index=0&id=26dd936f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dd936f",
  null
  
)

export default component.exports